<template lang="pug">
section#v-agenda.container
  h2 AGENDA
  ul.type
    li(@click='type = "onsite"', :class='{active: type === "onsite"}') 現場議程
    li(@click='type = "live"', :class='{active: type === "live"}') 分場直播議程
  ul.agenda
    li(:style='offset')
      .session
        h3 Special Lecture
        .row
          .time 08:50-09:10
          .issue
            .topic 《TechOrange 科技報橘》趨勢報告
            .speaker
              .company 流線傳媒
              | 創辦人暨社長 戴季全
        .row
          .time 09:10-09:30
          .issue
            .topic 5G 國際應用競爭的台灣戰略
            .speaker
              .company
                | 台灣大哥大 總經理
                br
                | AppWorks 董事長
              | 林之晨
        .row
          .time 09:30-09:50
          .issue
            .topic 迎向未來交通新願景
            .speaker
              .company 交通部
              | 部長 林佳龍
      .session
        h3
          label Session 1
          | Future of AI 智慧未來
        .row
          .time 09:50-10:10
          .issue
            .topic 地表最強 AI 晶片：可重組神經網絡
            .speaker
              .company Kneron 耐能智慧
              | 創辦人暨執行長 劉峻誠博士
        .row
          .time 10:10-10:30
          .issue
            .topic AWS 的 AI/ML 演進之路和最佳實踐
            .speaker
              .company Amazon Web Services
              | 機器學習系統架構師 楊仲豪
        .row
          .time 10:30-10:50
          .issue
            .topic 被閒聊耽誤的AI，交談式服務如何開創人機共工新世代？
            .speaker
              .company SysTalk.ai
              | 昕力資訊創新暨 AI 產品發展處副總經理 林秀明
        .row
          .time 10:50-11:10
          .issue
            .topic 遇見未來：使用 AI 重新定義金融科技
            .speaker
              .company Kronos Research
              | 量化研究員及交易員 郭子銘
        .row
          .time 11:10-11:40
          .issue
            .topic Panel：弱 AI 走向強 AI，智慧未來技術趨勢
        .row
          .time.break 11:40-13:00
          .issue
            .topic 午餐時間
      .session
        h3
          label Session 2
          | Future City 智慧生活
        .row
          .time 13:00-13:20
          .issue
            .topic 電動化革命 x 智慧共享力 打造未來城市移動生態系
            .speaker
              .company GoShare
              | 新事業總監 姜家煒
        .row
          .time 13:20-13:40
          .issue
            .topic 5G+AR：球場如何變得超智慧？
            .speaker
              .company 光禾感知科技
              | 創辦人暨執行長 王友光
        .row
          .time 13:40-14:00
          .issue
            .topic 找出智慧城市永續力的關鍵秘密
            .speaker
              .company 小智研發
              | 創辦人暨執行長 黃謙智
        .row
          .time 14:00-14:30
          .issue
            .topic Panel：綠色、共享，打造智慧城市兩大元素
      .session
        h3
          label Session 3
          | Future Manufacturing 未來製造
        .row
          .time 14:30-14:50
          .issue
            .topic 台達智造新藍圖，引領台廠製造升級起步
            .speaker
              .company 台達電子工業股份有限公司
              | 智能製造事業部總經理 林哲民
        .row
          .time.break 14:50-15:10
          .issue
            .topic 中場休息
      .session
        h3
          label Session 4
          | Future Democracy 網路民主對抗網路獨裁
        .row
          .time 15:10-15:30
          .issue
            .topic 2030 年的台灣網路民主新樣貌
            .speaker
              .company 流線傳媒
              | 創辦人暨社長 戴季全
        .row
          .time 15:30-15:50
          .issue
            .topic 備戰 2020 大選，民進黨如何用網路與選民溝通？
            .speaker
              .company 民進黨
              | 副秘書長 林飛帆
        .row
          .time 15:50-16:10
          .issue
            .topic 網路民主可行嗎？我的第一線觀察
            .speaker
              .company 自由軟體工作者、公民記者
              | 林雨蒼
        .row
          .time 16:10-16:30
          .issue
            .topic 網路民主時代的新政治人物之路
            .speaker
              .company 臺北市議員
              | 邱威傑
        .row
          .time 16:30-17:00
          .issue
            .topic Panel：亞洲網路民主先鋒之路-台灣民主科技下一步？
    li(:style='offset')
      .session
        .row
          .time 11:45-12:05
          .issue
            .topic 用電動機車鋪出一條智慧路網
            .speaker
              .company WeMo Scooter
              | 創辦人暨執行長 吳昕霈
        .row
          .time 12:05-12:10
          .issue
            .topic 換場/中場休息
        .row
          .time 12:10-12:30
          .issue
            .topic 如何把 chatbot 訓練成中文大師？
            .speaker
              .company SysTalk.ai
              | 昕力資訊創新暨 AI 產品發展處副總經理 林秀明
        .row
          .time 12:30-12:35
          .issue
            .topic 換場/中場休息
        .row
          .time 12:35-12:55
          .issue
            .topic 為什麼 AI 能夠「看」懂健康、讀懂「心」?
            .speaker
              .company 鉅怡智慧股份有限公司
              | 策略長 張紹堯
        .row
          .time 12:55-13:00
          .issue
            .topic 換場/中場休息
</template>

<script>
export default {
  name: 'Agenda',
  data() {
    return {
      type: 'onsite', // onsite, live
    }
  },
  computed: {
    offset() {
      if(this.type === 'onsite') {
        return { transform: 'translateX(0)' }
      } else if(this.type === 'live') {
        return { transform: 'translateX(-100%)' }
      }
    },
  },
}
</script>

<style lang="sass" scoped>
@import '~@/mixin.sass'

#v-agenda
  padding-bottom: 30px
  padding-top: 60px
h2
  +font(42px, white, null, 1.05px, 800, center)
  font-family: 'Montserrat Alternates'
  margin-bottom: 40px
.type
  +flex(center)
  list-style-type: none
  margin-bottom: 40px
  li
    +border(2px, transparent, 100px)
    +font(18px, white, null, .99px, bold)
    cursor: pointer
    margin-left: 10px
    margin-right: 10px
    padding: 10px
    transition: border-color .2s, color .2s
    &:hover, &.active
      color: #DFFF00
      border-color: #DFFF00
.agenda
  display: flex
  list-style-type: none
  overflow: hidden
  li
    flex: none
    transition: transform .4s
    width: 100%
    .session
      margin-bottom: 70px
      h3
        +font(20px, black, null, null, 800)
        background-color: #DFFF00
        display: inline-block
        font-family: 'Montserrat Alternates', 'Noto Sans TC', 'WenQuanYi Zen Hei', 'PingFang TC', 'Microsoft JhengHei'
        margin-bottom: 45px
        padding: 10px 15px 8px
        label
          margin-right: 1em
      .row
        display: flex
        margin-bottom: 35px
        .time
          +font(18px, #DFFF00, 24px, .99px, 500)
          flex: none
          margin-right: 30px
          width: 130px
          &.break
            color: white
        .issue
          display: flex
          .topic
            +font(18px, white, 24px, .4px, 500)
            flex: none
            margin-right: 50px
            width: 420px
            em
              color: #85E4FF
          .speaker
            +font(18px, white, 24px, 1px, 500)
            .company
              color: #DFFF00
@media (max-width: 1023px)
  #v-agenda
    padding-bottom: 20px
    padding-top: 30px
  h2
    +font(30px, null, null, .75px)
    margin-bottom: 30px
  .type
    margin-bottom: 30px
    li
      +font(14px, null, null, .77px)
      margin-left: 5px
      margin-right: 5px
      padding: 8px 10px
  .agenda
    li
      .session
        margin-bottom: 40px
        h3
          font-size: 14px
          margin-bottom: 20px
          padding: 7px 10px 6px
        .row
          margin-bottom: 25px
          .time
            +font(14px, null, 22px, .66px)
            margin-right: 5px
            width: 100px
          .issue
            flex-direction: column
            .topic
              +font(14px, null, 22px, .31px)
              margin-bottom: 6px
              margin-right: 0
              width: auto
            .speaker
              +font(12px, null, 18px, 0)
</style>
